import { render, staticRenderFns } from "./adminSymbols.vue?vue&type=template&id=95acb536"
import script from "./adminSymbols.vue?vue&type=script&lang=js"
export * from "./adminSymbols.vue?vue&type=script&lang=js"
import style0 from "./adminSymbols.vue?vue&type=style&index=0&id=95acb536&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports